/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import { Icon } from '../../icon/icon';
import { Text } from '../../text/text';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { Anchor } from '../../anchor/anchor';

import styles from './call_options_toggle.css';

/**
 * Renders the call options toggles (call, and callback) as anchors which call an event handler once clicked
 * This event handler is a callback function to it's parent container
 * @param {Object} props The properties
 * @param {Object} props.stateProps - stateProps including a mandatory event handler
 * @param {Object} props.visualProps - row vs column layout rendering, passed in via parent container
 * @returns {Node} Two call options toggles
 * @constructor
 */
const _CallOptionsToggle = ({ stateProps, visualProps, optInProps }) => {
    // @todo this could be split into two separate toggle components with appropriate visual props for icon and style
    const { callToggle, callBackToggle } = stateProps;
    const { breakpoint = pageContext.getProps().pageState.breakpoint, product } = stateProps;
    const callBackVisibility = product.getIn(['productMeta', 'contact', 'isCallBackAllowed']);
    const callDirectVisibility = product.getIn(['productMeta', 'contact', 'isCallDirectAllowed']);
    const xs = breakpoint === 'xs';
    const { eventHandler } = stateProps;
    const { inlineLabels = false } = visualProps || {};
    const { optInPhoneActive, optInEmailActive } = optInProps;
    const getCallOptionsColor = (toggle) => (toggle ? 'call_options_icon_active' : 'call_options_icon_inactive');
    return (
        <div className={styles.container}>
            <div className={styles.root}>
                { callDirectVisibility
                && (
                    <Anchor className={styles.anchor} href="javascript:;" onClick={() => eventHandler({ id: 'call' })}>
                        <SimpleFlexbox display="flex" column={!inlineLabels} itemsCenter="xs" margin="right">
                            <Icon
                                variant="ctm_phone"
                                color={getCallOptionsColor(callToggle)}
                                size={!xs ? 'xxlarge' : 'xxxlarge'}
                                animation={callToggle ? 'grow_rotate' : ''} />
                            <Text
                                variant="white_space_nowrap"
                                size="small"
                                color={getCallOptionsColor(callToggle)}>
                            &nbsp;Call
                            </Text>
                            { callToggle && <div className={ styles.activeArrow } /> }
                        </SimpleFlexbox>
                    </Anchor>
                ) }
                {((!optInEmailActive && callBackVisibility) || (optInEmailActive && callBackVisibility && optInPhoneActive))
                && (
                    <Anchor className={styles.anchor} href="javascript:;" onClick={() => eventHandler({ id: 'callBack' })}>
                        <SimpleFlexbox display="flex" column={!inlineLabels} itemsCenter="xs">
                            <Icon
                                variant="ctm_phone_call_back"
                                color={getCallOptionsColor(callBackToggle)}
                                size={!xs ? 'xxlarge' : 'xxxlarge'}
                                animation={callBackToggle ? 'buzz_out' : ''} />
                            <Text
                                variant="white_space_nowrap"
                                size="small"
                                color={getCallOptionsColor(callBackToggle)}>
&nbsp;Call back
                            </Text>
                            { callBackToggle && <div className={ styles.activeArrow } /> }
                        </SimpleFlexbox>
                    </Anchor>
                ) }
            </div>
        </div>
    );
};

_CallOptionsToggle.propTypes = {
    optInProps: PropTypes.shape({
        optInPhoneActive: PropTypes.bool,
        optInEmailActive: PropTypes.bool
    }),
    stateProps: PropTypes.shape({
        eventHandler: PropTypes.func.isRequired,
        callBackToggle: PropTypes.bool,
        callToggle: PropTypes.bool,
        breakpoint: PropTypes.string,
        product: PropTypes.shape({
            getIn: PropTypes.func
        })
    }).isRequired,
    visualProps: PropTypes.shape({
        inlineLabels: PropTypes.bool
    })
};

const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    let phoneActive = form.getIn(['applicant', 'optInPhone']);
    let emailActive = form.getIn(['applicant', 'optInEmail']);
    if (phoneActive === 'Y') phoneActive = true;
    else phoneActive = false;
    if (emailActive === 'Y') emailActive = true;
    else emailActive = false;
    const optInProps = {
        optInPhoneActive: phoneActive,
        optInEmailActive: emailActive
    };
    return {
        optInProps
    };
};

const CallOptionsToggle = connect(mapStateToProps)(_CallOptionsToggle);

export { _CallOptionsToggle, CallOptionsToggle };
